export default "__VITE_ASSET__CiBLs61B__"